export const UPDATE_ITEM_QNTY_REQUEST = 'UPDATE_ITEM_QNTY_REQUEST'
export const UPDATE_ITEM_QNTY_SUCCESS = 'UPDATE_ITEM_QNTY_SUCCESS'
export const UPDATE_ITEM_QNTY_FALIURE = 'UPDATE_ITEM_QNTY_FALIURE'
